/* Hero Carrossel — navegação nativa por scroll-snap, autoplay com pausa
   inteligente. Vanilla, idempotente, sem dependências (padrão do tema). */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.heroReady === 'true') return;
    root.dataset.heroReady = 'true';

    var track = root.querySelector('[data-carousel-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-dot]'));
    if (!track || slides.length < 2) return;

    var index = 0;
    var timer = null;
    var interval = (parseInt(root.dataset.interval, 10) || 6) * 1000;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.dataset.autoplay === 'true' && !reduceMotion;

    function goTo(i, smooth) {
      index = (i + slides.length) % slides.length;
      var left = slides[index].offsetLeft;
      track.scrollTo({ left: left, behavior: smooth === false ? 'auto' : 'smooth' });
    }

    function syncDots() {
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      /* As bolinhas ficam FORA do track, então o CSS não alcança o tema do
         slide ativo por seletor de irmão. O estado vem para o container. */
      var atual = slides[index];
      root.toggleAttribute(
        'data-active-light',
        !!(atual && atual.classList.contains('hero-carousel__slide--light-text'))
      );
    }

    /* Observa qual slide está visível (cobre swipe manual no mobile) */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            index = slides.indexOf(entry.target);
            syncDots();
          }
        });
      }, { root: track, threshold: 0.6 });
      slides.forEach(function (s) { io.observe(s); });
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function play() {
      if (!autoplay || timer) return;
      timer = setInterval(function () { goTo(index + 1); }, interval);
    }

    root.addEventListener('click', function (event) {
      var prev = event.target.closest('[data-carousel-prev]');
      var next = event.target.closest('[data-carousel-next]');
      var dot = event.target.closest('[data-carousel-dot]');
      if (prev) { goTo(index - 1); stop(); play(); }
      if (next) { goTo(index + 1); stop(); play(); }
      if (dot) { goTo(parseInt(dot.dataset.carouselDot, 10)); stop(); play(); }
    });

    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(index - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); goTo(index + 1); }
    });

    ['mouseenter', 'focusin', 'touchstart'].forEach(function (evt) {
      root.addEventListener(evt, stop, { passive: true });
    });
    ['mouseleave', 'focusout', 'touchend'].forEach(function (evt) {
      root.addEventListener(evt, play, { passive: true });
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { play(); }
    });

    syncDots();
    play();
  }

  function boot() {
    document.querySelectorAll('[data-hero-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
